export function getTipPriorityLabel(priority: number) {
  if (priority >= 4) return 'high';
  if (priority >= 3) return 'medium';
  return 'low';
}
